import { render, staticRenderFns } from "./legal-statement.vue?vue&type=template&id=1c5aed13&scoped=true"
var script = {}
import style0 from "./legal-statement.vue?vue&type=style&index=0&id=1c5aed13&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5aed13",
  null
  
)

export default component.exports